import { render, staticRenderFns } from "./settlement.vue?vue&type=template&id=207d5ffa&scoped=true&"
import script from "./settlement.vue?vue&type=script&lang=js&"
export * from "./settlement.vue?vue&type=script&lang=js&"
import style0 from "./settlement.vue?vue&type=style&index=0&lang=less&"
import style1 from "./settlement.vue?vue&type=style&index=1&lang=css&"
import style2 from "./settlement.vue?vue&type=style&index=2&id=207d5ffa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207d5ffa",
  null
  
)

export default component.exports